import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import {
  faArrowRight,
  faCheckCircle as faCheckCircleLight
} from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ButtonLink from 'components/shared/ButtonLink.styled';
import { LoggedUserContext } from 'context/logged-user/loggeduser.context';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/dist/client/router';
import Link from 'next/link';
import { useContext } from 'react';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import {
  StyledContent,
  StyledContentAction,
  StyledContentTitle,
  StyledHowTo,
  StyledHowToIcon,
  StyledHowToTitle,
  StyledImage,
  StyledLevel,
  StyledLevelHeader,
  StyledNumber,
  StyledTitle
} from './ManfrediteLevel.styled';

type LevelItemProps = {
  title: string;
  image: string;
  howTo: string;
  perks: string[];
  action?: boolean;
};

type LevelProps = {
  level: LevelItemProps;
  number: number;
};

const ManfrediteLevel = ({ level, number }: LevelProps) => {
  const { t } = useI18n('manfredite');
  const { locale } = useRouter();

  const { user } = useContext(LoggedUserContext);

  return (
    <StyledLevel>
      <StyledLevelHeader>
        <StyledNumber>
          <span>{number}</span>
        </StyledNumber>
        <StyledImage src={level.image} alt="" />
        <StyledTitle>{level.title}</StyledTitle>
      </StyledLevelHeader>
      <div>
        <StyledHowTo>
          <StyledHowToIcon>
            <FontAwesomeIcon icon={faCheckCircleLight} />
          </StyledHowToIcon>
          <div>
            <StyledHowToTitle>
              {t('path.manfredite-levels.howTo')}{' '}
            </StyledHowToTitle>
            <p>{level.howTo}</p>
          </div>
        </StyledHowTo>
        <StyledContent>
          <StyledContentTitle>
            {t('path.manfredite-levels.youWill')}
          </StyledContentTitle>
          <ul>
            {level.perks.map((p, i) => (
              <li key={i}>
                {level.perks.length > 1 && (
                  <FontAwesomeIcon icon={faArrowRight} />
                )}
                <div dangerouslySetInnerHTML={{ __html: p }}></div>
              </li>
            ))}
          </ul>
          {level.action && !user && (
            <StyledContentAction>
              <Link
                href={`${getAppUrl(APP_URLS.join, locale)}?locale=${locale}`}
                passHref
              >
                <ButtonLink variant="primary" sizes="sm">
                  <FontAwesomeIcon icon={faCheckCircle} />
                  <span>{t('path.manfredite-levels.cta')}</span>
                </ButtonLink>
              </Link>
            </StyledContentAction>
          )}
        </StyledContent>
      </div>
    </StyledLevel>
  );
};

export default ManfrediteLevel;
